import styled from 'styled-components';

export const Container = styled.div`
    margin: 20px 0; 
`;

export const Label = styled.div`
    font-size: 15px;
    color: #6A7D8B
`;

export const Value = styled.div`
    font-size: 37px;
    font-weight: bold;
    color: #101C40;

`;